import React, { useEffect, useMemo, useState } from "react";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';
import { Button, Col, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { deleteCatalogItem } from "store/actions";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import Select from "react-select"

const CatalogueTable = ({ List, loading,solutions,setSelectedSolution,selectedSolution }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

  const handleDelete = (catalogueId) => {
    dispatch(deleteCatalogItem(catalogueId))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction])

  const columns = useMemo(
    () => [

      {
        header: 'Catalogue Image',
        accessorKey: 'image',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          return (
            <div style={{ width: "50px", height: "50px" }}>
              <img src={`${process.env.REACT_APP_BASE_URL}${getValue()}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />
            </div>
          )
        },
      },
      {
        header: 'Catalogue Name',
        accessorKey: 'itemName',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          return (
            <p style={{ width: "240px", wordWrap: "break-word", whiteSpace: "normal", marginBottom: "0px" }}>
              {getValue()}
            </p>
          )
        },
      },
      {
        header: 'Description',
        accessorKey: 'itemDescription',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          return (
            <p style={{ width: "240px", wordWrap: "break-word", whiteSpace: "normal", marginBottom: "0px" }}>
              {getValue()}
            </p>
          )
        },
      },
      {
        header: 'Category',
        accessorKey: 'categoryName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Department',
        accessorKey: 'departmentName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'SKU',
        accessorKey: 'sku',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Model',
        accessorKey: 'model',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Solution',
        accessorKey: 'solutionName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Estimated Installation Time (mins)',
        // header: () => (
        //   <div
        //     style={{
        //       minWidth: '150px',
        //       whiteSpace: 'normal',
        //       wordWrap: 'break-word',
        //       overflow: 'hidden',
        //     }}
        //   >
        //     Estimated Installation Time (mins)
        //   </div>
        // ),

        accessorKey: 'estimatedInstallTimeInMins',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => {
          return (
            <p className="text-center" style={{ width: "240px", wordWrap: "break-word", whiteSpace: "normal", marginBottom: "0px" }}>
              {getValue()}
            </p>
          )
        },
        // size: 100,
        // minSize: 50,
        // maxSize: 100,
      },
      {
        header: 'Status',
        accessorKey: 'isActive',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ getValue }) => getValue() ? 'Active' : 'Inactive',
      },
      {
        header: 'Actions',
        id: 'actions', // Unique id for this column
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            navigate(`/createCatalogue?id=${rowData?.catalogueId}`)
            // You can handle the edit functionality here
            console.log('Edit clicked for row:', rowData);
          };

          return (
            <div className="d-flex gap-2 ">
              {permissions2?.map(item => item?.permissionName)?.includes("Edit Catalogues") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions2?.map(item => item?.permissionName)?.includes("Delete Catalogues") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.catalogueId); setOpenModal(true); }}
                className="mr-2 "
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
    ],
    []
  );

  //meta title
  document.title = "Zain Channels";

  return (
    <>
      <ConfirmationModal okText={"Confirm"} onCancel={() => { setDeleteId(''); setOpenModal(false); }} onOk={() => { setConfirmAction(true); }} isVisible={openModal} title="Delete Catalogue" content='Are You Sure You Want to Delete the Catalogue' />
      <div className="">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Data Tables" /> */}
          <Col xs={6} md={3} className="mb-4">
            <Label for="solution" className='mt-1'>Solution</Label>
            <Select
              id="solution"
              options={solutions?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))}
              value={solutions?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))?.find(option => option?.value == selectedSolution) || ""}
              onChange={option => { setSelectedSolution(option?.value); }}
              placeholder="Select Solution"
              isClearable={true}
              styles={{
                container: (base) => ({
                  ...base,
                  maxWidth: '200px',
                }),
              }}
            />
          </Col>
          <TableContainer
           
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Catalogues"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
}


export default CatalogueTable;